import {Component, EventEmitter, HostBinding, HostListener, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {Serializer} from "../../../../shared/interfaces/serializer";
import {SavedReport} from "../../../../shared/interfaces/saved-reports";
import {environment} from '../../../../../environments/environment';
import {enlargeTextAnimation} from '../../../../shared/animations/enlarge-text.animation';
import {enterOpacityAnimation} from '../../../../shared/animations/show-opacity.animation';
import {showSlideRightAnimation} from '../../../../shared/animations/show-slide-right';
import {SavedReportComponentObject} from '../../../../shared/classes/saved-report-component-object';
import {ReportTableRowStore} from "./report-table-row.store";

@Component({
  selector: 'app-report-table-row',
  templateUrl: './report-table-row.component.html',
  styleUrls: ['./report-table-row.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    enlargeTextAnimation,
    enterOpacityAnimation,
    showSlideRightAnimation
  ],
  providers: [
    ReportTableRowStore
  ]
})
export class ReportTableRowComponent implements OnInit {
  public loading: boolean = false;

  @Input() public report: SavedReportComponentObject;
  @Input('loading') public set _setLoading(loading: boolean) {
    this.loading = loading;
    this.loadingClass = loading;
  };

  @Input() public lockDrag: boolean = false;

  @Output() public readonly onInfo: EventEmitter<void> = new EventEmitter<void>();
  @Output() public readonly onOpenInNewTab: EventEmitter<void> = new EventEmitter<void>();
  @Output() public readonly onOpen: EventEmitter<void> = new EventEmitter<void>();
  @Output() public readonly onPublic: EventEmitter<void> = new EventEmitter<void>();
  @Output() public readonly onDragActive: EventEmitter<boolean> = new EventEmitter<boolean>();

  @HostBinding('@enterOpacity') public opacityAnimate: boolean = true;
  @HostBinding('class.loading') public loadingClass: boolean = false;


  @HostListener('mouseenter') public onMouseEnter(): void {
    if (!this.loading && this.report.parameters$.value) {
      this.enlargeText = 'large';
      this.showActions = true;
    }
  }

  @HostListener('mouseleave') public onMouseLeave(): void {
    if (!this.loading && this.report.parameters$.value) {
      this.enlargeText = 'normal';
      this.showActions = false;
    }
  }

  @HostListener('click') public onClick(): void {
    if (!this.loading && this.report.parameters$.value) {
      this.onOpen.emit();
    }
  }

  public readonly badgeColors: Record<string, string> = {
    performance: '#6aa9da',
    cycle: '#a4d2d7',
    chart: '#122a62',
    dashboard: '#abc9f1',
    affinity: '#dbeafe',
    'transaction-id': '#b9bdef',
    'path-explorer': '#9dc5fe'
  };

  public enlargeText: string = 'normal';
  public showActions: boolean = false;

  constructor(
    private readonly _reportTableRowStore: ReportTableRowStore
  ) { }

  ngOnInit(): void {
    this._reportTableRowStore.load(this.report);
  }

}
